export const UMB_USER_ITEM_REPOSITORY_ALIAS = 'Umb.Repository.User.Item';
export const UMB_USER_ITEM_STORE_ALIAS = 'Umb.ItemStore.User';
